const getParentTd = (el: HTMLElement | null) => (el ? el.closest("td") : null);

const getNextTd = (el: HTMLElement | null) => {
  const currentTd = getParentTd(el);
  if (!currentTd) return null;
  return currentTd.nextElementSibling;
};

export const getNextInput = (el: HTMLElement | null, type: string = "text") => {
  const nextTd = getNextTd(el);
  if (!nextTd) return null;
  let nextInput: HTMLInputElement | null = null;
  switch (type) {
    case "text":
      nextInput = nextTd.querySelector("input");
      break;
    case "date":
      nextInput = nextTd.querySelector("input[type='hidden']");
      break;
    default:
      break;
  }
  return nextInput ?? null;
};
